import Page from '../../../../../components/PageWrapper';
import { useState } from 'react';
import GTable from '../../../../../components/elements/GTable';
import useModal from '../../../../../hooks/modalHook';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { onRemoveFilter } from '../../../../../utils/miscFunctions';
import useRoute from '../../../../../hooks/routesHook';
import { Claim } from '../../../../../models/claim/Claim';
import { useQuery } from '@tanstack/react-query';
import { useClaim } from '../../../../../hooks/claimHook';
import { useTableFilters } from '../../../../../hooks/useTableFilters';
import TableFilter from '../../../../../components/elements/GTable/InGTableComponents/TableFilter';
import { ITableFilterItem } from '../../../../../resources/interfaces';
import TableFilterForm from '../../../../../components/elements/GTable/InGTableComponents/TableFilter/TableFilterForm';
import { Edit } from 'lucide-react';
import { ITableRowAction } from '../../../../../components/elements/GTable/GTable';

interface ClaimsContent {
    amount: number;
    claimNumber: string;
    claimStage: string;
    createdOn: Date;
    customerName: string;
    customerPhone: string;
    expiry: Date;
    ncdEffect: string;
    paid: boolean;
    policyInception: Date;
    policyNumber: string;
    protectionType: string;
    reviewStage: string;
    status: any;
    updatedOn: Date;
}
export interface ClaimsProps {
    content: ClaimsContent[];
    empty: boolean;
    first: boolean;
    last: true;
    number: number;
    numberOfElements: number;
    pageable: any;
    size: number;
    sort: any;
    totalElements: number;
    totalPages: number
}

const NonAutoClaims = (): JSX.Element => {
    const navigate = useNavigate();
    const { getDashboardBase } = useRoute();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchString, setSearchString] = useState<string>('');
    const [showPerPage, setShowPerPage] = useState<number>(50);
    const { ModalComponent } = useModal();
    const [currentPage, setCurrentPage] = useState<number>(searchParams.get('page') ? Number(searchParams.get('page')) : 0);
    const [openFilter, setOpenFilter] = useState<boolean>(false)


    const getTableActions = (data: Claim): ITableRowAction[] => {
        const actions = [{
            label: 'Edit',
            icon: <Edit className='h-4 w-4' />,
            callback: (claim: Claim) => {
                navigate(`${getDashboardBase()}/claims/${data?.claimNumber}/edit?type=non-motor&isUpdate=true`, { replace: true });
            },
            data: data
        },]

        return actions;
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.set('page', page.toString());
            return newParams;
        });
    };

    const { columns, getAllClaimsList, claimsPaginationData, getDefaultFilters, fetchClaimStatistics } = useClaim({ getTableRowActions: getTableActions });

    const { filters: tableFilters, setFilters, getFilterValue, resetFilters } = useTableFilters({
        initialFilters: getDefaultFilters(),
        syncWithUrl: true,
    });

    const reviewStage = getFilterValue('stage');
    const policyType = getFilterValue('policy_type');

    const { data: claimsData, isLoading: claimsLoading } = useQuery({
        queryKey: ['getAllClaimsList', showPerPage, currentPage, reviewStage, policyType, searchString],
        queryFn: () => getAllClaimsList(currentPage, showPerPage, searchString, policyType, reviewStage)
    });

    // const { data: claimsStatisticsData, isLoading: claimsStatisticsLoading } = useQuery({
    //     queryKey: ['fetchClaimStatistics'],
    //     queryFn: () => fetchClaimStatistics()
    // });

    // console.log("claims", claimsData)


    return (
        <Page title="Claims">
            <div className="bg-white dark:bg-darkBg w-full min-h-full p-5 rounded-lg shadow-md dark:shadow-darkBg-shadow">

                <div className="">
                    <div className="inline-flex items-center gap-2 mb-2 dark:text-darkBg-mainText">
                        <div className="h-8 w-2 bg-gradient-to-b from-yellow-500 to-yellow-700 rounded"></div>
                        <h2 className="font-semibold text-3xl">Non Motor Claims</h2>
                    </div>

                    <p className="text-sm text-slate-400 dark:text-darkBg-subText">
                        View a list of all claims and associated details.
                    </p>
                </div>

                {/* <div className="mt-10">
                    <SummaryOverview data={claimsData} />
                </div> */}

                <div className="overflow-x-auto mt-4">
                    <GTable
                        columns={columns}
                        data={claimsData ?? []}
                        classes="h-fit"
                        onSearch={(searchString: string) => setSearchString(searchString)}
                        searchPlaceholder={'Search by customer name...'}
                        tableType={'claims'}
                        paginationData={claimsPaginationData}
                        onPageChange={handlePageChange}
                        showPerPage={showPerPage}
                        loading={claimsLoading}

                        onShowPerPageChange={(page: number) => setShowPerPage(page)}
                        selectedFilters={tableFilters}
                        onRemoveFilter={(filter: ITableFilterItem, index: number) => {
                            onRemoveFilter(filter, index, tableFilters, setFilters);
                        }}
                        showFilter={
                            <TableFilter
                                openFilter={openFilter}
                                onFilterChange={(filterState: boolean) => setOpenFilter(filterState)}
                                content={
                                    <TableFilterForm
                                        filters={tableFilters}
                                        getValues={(filters: ITableFilterItem[]) => {
                                            setFilters(filters);
                                            setOpenFilter(false);
                                        }}
                                        onResetFilters={() => resetFilters(getDefaultFilters())}
                                    />
                                }
                            />
                        }
                    />
                </div>

            </div>
            <ModalComponent />
        </Page>
    );
};

export default NonAutoClaims;
